import { useState, useRef, useEffect } from 'react'
import ReactPlayer from 'react-player'
import {
    Box, Center, VStack, HStack, Button, Spinner, useToast, Image, Alert, AlertTitle, AlertDescription 
  } from '@chakra-ui/react';
import {useWeb3React } from "@web3-react/core"
import {toDec, toBN} from '../lib/bn'
import nfts from '../lib/nfts'
import { getMeta } from '../lib/nftList'

const YieldCard = (props) => {
    const {account, library} = useWeb3React()
    const toast = useToast()
    const toastIdRef = useRef()
    const [processing, setProcessing] = useState(false)
    const trimDec = (txt,num) => {
        let ar = txt.split('.')
        if(ar.length===1) return ar[0]
        return ar[0] + '.' + ar[1].substr(0,num)
    }

    const withdraw = async () => {
        setProcessing(true)
        toastIdRef.current = toast({
            title: 'Withdrawal pending',
            status: 'info',
            isClosable: true,
            duration: 120000
        })
        try{
            let tx = await nfts.batchYield.withdraw(library.getSigner(account),account)
            toast.update(toastIdRef.current,{
                title: 'Sent withdraw tx to blockchain. Awaiting confirmation',
                status: 'info',
                isClosable: true,
                duration: 120000
            })
            await nfts.confirm(tx.hash)
            toast.update(toastIdRef.current,{
                title: 'Withdraw successful',
                status: 'success',
                isClosable: true,
                duration: 2000
            })
            await props.updateYield(account)
            setProcessing(false)

        } catch(e){
            toast.update(toastIdRef.current,{
                title: 'Something went wrong. Please try again.',
                status: 'error',
                isClosable: true,
                duration: 2000,
                
            })
            setProcessing(false)
            
        }
    }

    return <div style={{marginTop: 30, textAlign: 'center'}}>
        <div><div style={{display: 'inline-block', fontSize: 15, marginRight: 4, marginBottom: 5}}>Yield:</div> <b>{trimDec(props.yield,5)}</b> <div style={{display: 'inline-block', fontSize: 13}}>MATIC</div></div>
        {(!props.hasAccess && props.yield!=='0') && <Alert status='error'>
            <AlertTitle>No Access Token</AlertTitle>
            <AlertDescription>You need an access token to withdraw your yield</AlertDescription>
        </Alert>}
        <div style={{textAlign: 'center'}}><Button colorScheme='blue' variant='solid' disabled={props.yield==='0' || !props.hasAccess} onClick={withdraw} isLoading={processing} style={{marginTop: 10, textAlign: 'center'}}>Withdraw</Button></div>
    </div>
}

const WithdrawCard = (props) => {
    const {account, library} = useWeb3React()
    const [processing, setProcessing] = useState(false)
    const toast = useToast()
    const toastIdRef = useRef()

    const withdraw = async () => {
        setProcessing(true)
        toastIdRef.current = toast({
            title: 'Withdrawal pending',
            status: 'info',
            isClosable: true,
            duration: 120000
        })
        try{
            let tx = await nfts.yieldToken.withdraw(library.getSigner(account),props.tokenId)
            toast.update(toastIdRef.current,{
                title: 'Sent withdraw tx to blockchain. Awaiting confirmation',
                status: 'info',
                isClosable: true,
                duration: 120000
            })
            await nfts.confirm(tx.hash)
            toast.update(toastIdRef.current,{
                title: 'Withdraw successful',
                status: 'success',
                isClosable: true,
                duration: 2000
            })
            await props.updateYield(props.tokenId)
            setProcessing(false)
            props.back()

        } catch(e){
            toast.update(toastIdRef.current,{
                title: 'Something went wrong. Please try again.',
                status: 'error',
                isClosable: true,
                duration: 2000,
                
            })
            setProcessing(false)
            
        }
        
    }

    return <div style={{marginTop: 20}}>
        <HStack>
            <div style={{height: 520, width: 420, borderRadius: 10, overflow: 'hidden', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)'}}>
                <ReactPlayer url={props.animation_url} playing loop height={530} width={450} style={{position: 'relative', left: -5, top: -5}} />
            </div>
            <div style={{ height: 535, width: 380, padding: 10}}>
                <div style={{marginLeft: 20, marginTop: 20, color: '#1f82e2', cursor: 'pointer'}}  onClick={props.back}>{'<-'} Back</div>
                <div style={{fontSize: 30, fontWeight: 'bold', marginLeft: 20, marginTop: 10}}>{props.name}</div>
                <div style={{marginLeft: 20, marginTop: 10}}>{props.description}</div>
                <div style={{marginLeft: 20, marginTop: 10}}>TokenId: {props.tokenId}</div>
                <div style={{marginLeft: 20, marginTop: 10}}>Yield: {props.yield} <div style={{display: 'inline-block', fontSize: 12}}>MATIC</div></div>
                {!props.hasAccessToken && 
                    <div style={{marginLeft: 20, marginTop: 10, color: 'red'}}>No Access Token</div>
                }
                {props.hasAccessToken && props.yield>0 &&
                    <Center>
                        <Button colorScheme='blue' variant='solid' disabled={!props.yield>0} onClick={withdraw} isLoading={processing} style={{marginTop: 30}}>Withdraw {props.yield} MATIC</Button>
                    </Center>
                }
            </div>
    </HStack>
    </div>
}

const YieldTokenCard = (props) => {
    
    return <div style={{width: 250, height: 400, display: 'inline-block', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)', borderRadius: 10, padding: 0, margin: 7, textAlign: 'left'}}>
        <VStack style={{height: '100%', textAlign: 'left'}} >
            <Image src={props.meta.image} alt={props.name}/>
            <div style={{textAlign: 'center', width: '80%', fontSize: 14, fontWeight: 'bold'}}>{props.meta.name}</div>
            <div style={{textAlign: 'center', width: '80%', fontSize: 12}}>TokenId: {props.tokenId}</div>
        </VStack>
    </div>
    
}

const MyYieldTokens = (props) => {
    const {account, library} = useWeb3React()
    const [processing, setProcessing] = useState(false)
    const [meta, setMeta] = useState(null)
    const [selected, setSelected] = useState(null)
    const [totalYield,setYield] = useState(null)
    const [hasAccess,setHasAccess] = useState(null)

    
    useEffect(()=>{
        console.log('getting meta')
        getMeta().then(m=>{
            let _meta = {}
            m.forEach(t=>_meta[t.url]=t)
            setMeta(_meta)
        })
        console.log('getting yield')
        if(account)nfts.batchYield.getYield(account).then(yield_=>{
            setYield(toDec(yield_,18))
        })
        console.log('checking access token')
        if(account)nfts.accessToken.balanceOf(account).then(bal=>setHasAccess(bal.gt(toBN(0))))
    },[account])
    

    const showWithdraw = (tokenId, _meta, _yield) => {
        console.log(tokenId)
        _meta.yield = _yield
        _meta.tokenId = tokenId
        setSelected(_meta)
    }

    const updateYield = async (account) => {
        let y = await nfts.batchYield.getYield(account)
        setYield(toDec(y,18))
    }

    return (
        <>
        {!selected &&
            <VStack>
            {totalYield && <YieldCard yield={totalYield} updateYield={updateYield} hasAccess={hasAccess}/>}
            {(!props.yieldTokens || !meta) && account && 
                <div style={{fontSize:15, marginTop: 300}}><Spinner size='lg' /></div>
            }
            {!account && <div style={{marginTop: 280, boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)', padding: 20, borderRadius: 10}}>Please connect your wallet to view your yield tokens</div>}
            {account && props.yieldTokens && meta && props.yieldTokens.length===0 &&
                <div style={{marginTop: 280, boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)', padding: 20, borderRadius: 10}}>There are no Yield Tokens in this wallet</div>
            }
            
            {props.yieldTokens && meta && props.yieldTokens.length>0 &&
                <div style={{width: 800, textAlign: 'center', marginTop: 40, marginBottom: 50}}>
                    {
                        props.yieldTokens.map(token => <YieldTokenCard key={token.tokenId.toNumber()} tokenId={token.tokenId.toNumber()} yield={token.yield?toDec(token.yield,18,4):0} meta={meta[token.uri]} hasAccessToken={props.hasAccessToken} onClick={showWithdraw}/>)
                    }
                </div> 
            }
            </VStack>
        }
        {selected && 
            <WithdrawCard hasAccessToken={props.hasAccessToken} {...selected} back={()=>setSelected(null)} updateYield={props.updateYield}/>
        }
        </>
        
    )
}

export default MyYieldTokens

